/* eslint-disable */
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Typography, Box, Grid, IconButton, Tooltip } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import _ from 'lodash';

export default function Configuration(props) {

  const navigate = useNavigate();
  const screenCode = 'CONFIGURATION';
  const [configurationData, setConfigurationData] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [configTypeList, setConfigTypeList] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);


  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isConfigerFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityID: 0,
    configurationTypeID: 0,
    configurationValue: '',
    valuePriority: '',
    //messuringUnit: 0
  });

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Save",
    pageheadername: "Configuration"
  });

  const ProductSaveSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number().notRequired(),
    configurationTypeID: Yup.number().min(1, 'Please Select Configuration type').required('Configuration type required'),
    configurationValue: Yup.string().required('Configuration Value required'),
    valuePriority: Yup.string().required('Value Priority required').matches(/^[0-9]{1,9}([.][0-9]{1,9})?$/, 'Only allow numbers'),
    //messuringUnit: Yup.number().min(1, 'Please Select Messuring Unit').required('Messuring Unit required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      configurationTypeID: formData.configurationTypeID,
      configurationValue: formData.configurationValue,
      valuePriority: formData.valuePriority,
      //messuringUnit: formData.messuringUnit
    },

    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      trackPromise(saveConfiguration(values));
    },
  });

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  async function saveConfiguration(values) {
    if (pageProps.isEdit == false) {
      var formdata = {
        configurationValueID: parseInt(0),
        configurationTypeID: parseInt(values.configurationTypeID),
        groupID: parseInt(values.groupID),
        operationEntityID: parseInt(values.operationEntityID),
        measuringUnit: parseInt(0),
        value: values.configurationValue,
        valuePriority: parseInt(values.valuePriority),
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
      }
      var res = await services.SaveConfiguration(formdata);
      if (res.statusCode === "Success") {
        toast.success("Configuration Saved Successfully");
        trackPromise(GetAllConfigarationValues());
        clearAll();
      } else if (res.statusCode === "Error" && res.data == -1) {
        toast.error("Value Priority Already Exists");
      } else {
        toast.error("Error Occured in Configuration Create");
      }
    }
    else {
      var formdata = {
        configurationValueID: parseInt(pageProps.editingID),
        configurationTypeID: parseInt(values.configurationTypeID),
        groupID: parseInt(values.groupID),
        operationEntityID: parseInt(values.operationEntityID),
        measuringUnit: parseInt(0),
        value: values.configurationValue,
        valuePriority: parseInt(values.valuePriority),
        createdBy: parseInt(TokenDecoder.getUserIDFromToken())
      }
      var res = await services.SaveConfiguration(formdata);
      if (res.statusCode === "Success") {
        toast.success("Configuration Updated Successfully");
        trackPromise(GetAllConfigarationValues());
        clearAll();
        setPageProps({
          ...pageProps,
          editingID: 0,
          isEdit: false,
          submitButtonName: "Save",
        })
      } else if (res.statusCode === "Error" && res.data == -1) {
        toast.error("Value Priority Already Exists");

      } else {
        toast.error("Error Occured in Configuration update");
      }
    }
  }
  async function clearAll() {
    setValues({
      ...values,
      configurationTypeID: 0,
      configurationValue: '',
      valuePriority: '',
      //messuringUnit: 0
    })
  }

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    trackPromise(GetAllConfigarationValues());
  }, [formik.values.operationEntityID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'CONFIGURATIOIN');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    trackPromise(
      GetAllGroups(),
      GetAllConfigurationsTypes()
    );
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  async function GetAllConfigurationsTypes() {
    var res = await services.GetAllConfigurationTypesForDropDown();
    if (res != null) {
      setConfigTypeList(res);
    }
  }

  async function GetAllConfigarationValues() {
    var res = await services.GetAllConfigarationValues(formik.values.groupID, formik.values.operationEntityID);
    setConfigurationData(res);
  }

  function setEditData(data, index) {
    var array = [...configurationData];
    array.splice(index, 1);
    setValues({
      ...values,
      configurationTypeID: data.configurationTypeID,
      configurationValue: data.value,
      valuePriority: data.valuePriority,
      messuringUnit: data.measuringUnit
    })
    setPageProps({
      ...pageProps,
      editingID: data.configurationValueID,
      isEdit: true,
      submitButtonName: "Update",
    })
    setConfigurationData(array);
  }

  async function DeleteConfigaration(value) {
    var formdata = {
      configurationValueID: parseInt(value.configurationValueID),
      modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    var res = await services.DeleteConfigaration(formdata);
    if (res.statusCode === "Success") {
      toast.success("Configuration Deleted Successfully");
      trackPromise(GetAllConfigarationValues());
    } else {
      toast.error("Error Occured in Configuration Delete");
    }
  }

  return (
    <>
      <LoadingComponent />
      <Page title="Configuration  |  FAPS">
        <Container>
          <CommonPageHeader
            path="/dashboard"
            btname="Back"
            pageName={pageProps.pageheadername}
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    name="groupID"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value="0"> Select Group</MenuItem>
                    {groupList.map((option) => (
                      <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center"
                    value={formik.values.operationEntityID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>All Fresh Collection Centers</MenuItem>
                    {operationEntityList.map((option) => (
                      option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Configuration type *"
                    name="configurationTypeID"
                    value={formik.values.configurationTypeID}
                    onChange={formik.handleChange}
                    {...getFieldProps('configurationTypeID')}
                    error={Boolean(touched.configurationTypeID && errors.configurationTypeID)}
                    helperText={touched.configurationTypeID && errors.configurationTypeID}
                  >
                    <MenuItem key={0} value={0}>Select Configuration type</MenuItem>
                    {configTypeList.map((option) => (
                      <MenuItem key={option.configurationTypeID} value={option.configurationTypeID}>
                        {option.configurationTypeName}
                      </MenuItem>
                    ))}

                  </TextField>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Configuration Value *"
                      value={formik.values.configurationValue}
                      onChange={formik.handleChange}
                      {...getFieldProps('configurationValue')}
                      error={Boolean(touched.configurationValue && errors.configurationValue)}
                      helperText={touched.configurationValue && errors.configurationValue}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Value Priority *"
                      value={formik.values.valuePriority}
                      onChange={formik.handleChange}
                      {...getFieldProps('valuePriority')}
                      error={Boolean(touched.valuePriority && errors.valuePriority)}
                      helperText={touched.valuePriority && errors.valuePriority}

                    />
                  </Grid>
                  {/* <TextField
                    select
                    fullWidth
                    size="small"
                    label="Messuring Unit *"
                    value={formik.values.messuringUnit}
                    onChange={formik.handleChange}
                    {...getFieldProps('messuringUnit')}
                    error={Boolean(touched.messuringUnit && errors.messuringUnit)}
                    helperText={touched.messuringUnit && errors.messuringUnit}
                  >
                    <MenuItem key={0} value={0}> Select Messuring Unit</MenuItem>
                    <MenuItem value={1}> Unit</MenuItem>
                    <MenuItem value={2}> Kg</MenuItem>
                  </TextField> */}
                  <Grid item md={4} xs={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                      <LoadingButton
                        size="small"
                        type="button"
                        color='error'
                        variant="outlined"
                        onClick={() => clearAll()}
                      >
                        Clear
                      </LoadingButton>
                      <LoadingButton
                        size="small"
                        type="submit"
                        color='secondary'
                        variant="outlined"
                      >
                        {pageProps.submitButtonName}
                      </LoadingButton>
                    </Stack>
                  </Grid>
                </Stack>
                {configurationData.length != 0 ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card style={{ justifycontent: 'center', width: '85rem' }} >
                      <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Configuration Type</TableCell>
                              <TableCell align="center">Configuration Value</TableCell>
                              <TableCell align="center">Value Priority</TableCell>
                              {/* <TableCell align="center">Measuring Unit</TableCell> */}
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {configurationData.map((row, i) => (
                              <TableRow key={row.configurationTypeName}>
                                <TableCell align="center">
                                  {row.configurationTypeName}
                                </TableCell>
                                <TableCell align="center">
                                  {row.value}
                                </TableCell>
                                <TableCell align="center">
                                  {row.valuePriority}
                                </TableCell>
                                {/* <TableCell align="center">
                                  {row.measuringUnit == 1 ? "Unit" : "Kg"}
                                </TableCell> */}
                                <TableCell align="center">
                                  <Tooltip title="Edit Configuration">
                                    <IconButton aria-label="delete">
                                      <EditIcon onClick={() => setEditData(row, i)} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Delete Configuration">
                                    <IconButton aria-label="delete">
                                      <DeleteIcon onClick={() => DeleteConfigaration(row)} />
                                    </IconButton>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Stack> : null}
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  )
}